import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { translate } from '../Services/translation';
import { useDispatch } from 'react-redux';
import { setFilterTabOpen } from "../Actions/FacetedSearch.action";
import { Svg } from './Svg';
const FilterTriggerButton = () => {
    const dispatch = useDispatch();
    return (_jsxs("button", { onClick: () => dispatch(setFilterTabOpen(true)), className: "filter-button button", children: [translate("nmas.category.filter"), " ", _jsx(Svg, { icon: "filter" })] }));
};
export default FilterTriggerButton;
